import requestIdleCallback from '@/helpers/RequestIdleCallback';
import { PromiseTimeout } from '@/helpers/PromiseTimeout';
import ReactAnimatedEllipsis from 'react-animated-ellipsis';

export const Loading = ({ ...props }) => {
  const emitter = useMitt();

  const { t } = useTranslation();

  const { progress, completed } = useAssetProgress();

  const ready = useAppStore((state) => state.ready);
  const setReady = useAppStore((state) => state.setReady);
  // const verified = useAppStore((state) => state.verified);

  useEffect(() => {
    (async () => {
      if (completed) {
        await PromiseTimeout(500);
        requestIdleCallback(() => {
          setReady(true);
        });
      }
    })();
  }, [completed]);

  return (
    <div className={cn('frame-brown full', ready && 'hidden')}>
      <div
        className="bar full bg-darkbrown origin-left transition-transform duration-500"
        style={{ transform: `scaleX(${progress})` }}
      />
    </div>
  );
};
